import * as React from 'react';
import { connect } from 'react-redux';
import '../css/SuperUserPageView.css';
import { TooltipCont } from '../../../infrastructure/tooltips';
import { getScrollbarWidth } from '../../../lib/helpers';
import { IPosterImage } from '../../../infrastructure/interfaces';
import HeaderBar from '../../HeaderBar/HeaderBar';
import DeleteConfirmModal from '../../Modals/DeleteConfirmModal';
import { contentImagesRelativePath } from '../../../constants';
import {createPosterImage} from "../../../actions/actions";
import PosterCreatorModal from '../../Modals/PosterCreatorModal/PosterCreatorModal';
import {archivePosterImage} from '../../../actions/actions'

export interface IManagePosterImagesProps {
    posterImages?: IPosterImage[];
    createPosterImage(posterImageName: string, formData?: FormData): void;
    archivePosterImage(posterImage: IPosterImage): void;
}

export interface IManagePosterImagesState {
    showCreateModal: boolean;
    selectedPosterImage?: IPosterImage;
    showArchivePosterModal: boolean;
}

//TODO: IMplement state object
const mapStateToProps = (state: any) => {
    return {
        posterImages: state.wizard.posterImages
    };
};

const mapDispatchToProps = (dispatch: any): any => {
    return {
        createPosterImage: (posterImageName: string, formData: FormData) => {
            dispatch(createPosterImage(posterImageName, formData));
        },
        archivePosterImage: (posterImage: IPosterImage) => {
            dispatch(archivePosterImage(posterImage));
          },
    };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class ManagePosterImagesTable extends React.Component<IManagePosterImagesProps, IManagePosterImagesState> {
    tableRow: HTMLElement;
    componentDidMount() {
    }

    constructor(props: IManagePosterImagesProps) {
        super(props);
        this.state = {
            showCreateModal: false,
            showArchivePosterModal: false,
        };
    };

    onEditPosterImage = (posterImage: IPosterImage) => {
        this.setState({
            showCreateModal: true,
            selectedPosterImage: posterImage,
            showArchivePosterModal: false,
        });
    };

    onCreatePosterImage() {
        this.setState({
            showCreateModal: true,
            showArchivePosterModal: false,
            selectedPosterImage: undefined,
        });
    }

    onArchiveRequest(posterImage: IPosterImage) {
        this.setState({
            showCreateModal: false,
            showArchivePosterModal: true,
            selectedPosterImage: posterImage
        });
    }

    archivePosterImage(posterImage: IPosterImage) {
        this.props.archivePosterImage(posterImage);
    }

    closeModals() {

        this.setState({
            showCreateModal: false,
            showArchivePosterModal: false,
            selectedPosterImage: undefined,
        });
    }

    render() {

        const {
            posterImages,
        } = this.props;
        const nonNullPosterImages = posterImages ? posterImages : [];

        return (
            <div className="root-container">
                <HeaderBar />
                <div className="inner-su-container">
                    <div className="manage-items-row-offsetRight">

                        <div className="in-row-text-container">
                            Manage Poster Images
                        </div>

                        <div className="in-row-button-container">
                            <button
                                className="btn primary-green large"
                                onClick={() => {this.onCreatePosterImage();}}
                                title={TooltipCont.CREATE_COVER_PHOTO}
                            >
                                Upload Poster Image
                            </button>
                        </div>
                    </div>
                    <table className="table-scrollableSU documents-table">
                        <thead style={{ paddingRight: getScrollbarWidth() }}>
                        <tr>
                            <th>Name</th>
                            <th>Image</th>
                            <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody className="document-table-body">
                        {nonNullPosterImages.map((s: IPosterImage) =>
                            <tr key={s.id} ref={tr => this.tableRow = tr!}>
                                <td>
                                    {s.name}
                                </td>
                                <td>
                                    <img className="inlineImagesTableImage" src={contentImagesRelativePath + s.web_image_path} />
                                </td>
                                <td>
                                    <div className="button-wrapper">
                                    <button
                                        className="btn primary-red"
                                        onClick={() => this.onArchiveRequest(s)}
                                        title={TooltipCont.ARCHIVE}
                                        disabled={false}
                                        >
                                        Archive
                                    </button>
                                    </div>
                                </td>
                            </tr>)}
                        </tbody>
                    </table>

                    <PosterCreatorModal
                        show={this.state.showCreateModal}
                        onClose={() => this.closeModals()}
                        onSubmit={(posterImageName: string, formData: FormData) => {
                            this.closeModals();
                            this.props.createPosterImage(posterImageName, formData);
                            }
                        }
                    />


                    <DeleteConfirmModal
                        show={this.state.showArchivePosterModal}
                        onClose={() => this.closeModals()}
                        onSave={() => {
                            if(this.state.selectedPosterImage) {
                                this.archivePosterImage(this.state.selectedPosterImage);
                            }
                            this.closeModals();
                        }}
                        title='Are you sure you want to archive this image?'
                    />
                </div>
            </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/SuperUser/components/ManagePosterImages.tsx